import { z } from 'zod';
import { externalInviteStatusSchema, identitySourceSchema, roleSchema, userStatusSchema } from './enums';
/**
 * A member, as an administrator sees them. Distinct from `Principal` (the
 * signed-in caller's own view of themselves via GET /api/me) — this is the
 * admin-facing shape for the member list.
 */
export const memberSchema = z.object({
    id: z.string(),
    entraObjectId: z.string(),
    displayName: z.string(),
    department: z.string().nullable(),
    /** Set only for an External partner (their invited email). Always null for a Workforce member, who shows `department` instead. */
    email: z.string().nullable(),
    status: userStatusSchema,
    suspendedReason: z.string().nullable(),
    roles: z.array(roleSchema),
    /** Workforce (staff) or External (invited business partner). */
    identitySource: identitySourceSchema,
    createdAt: z.coerce.date(),
    lastSeenAt: z.coerce.date().nullable(),
});
/**
 * The exact shape a directory search result already has — the client just
 * re-submits the row an administrator clicked "Invite" on, rather than the
 * API re-searching the directory to confirm who was picked.
 */
export const inviteMemberSchema = z.object({
    entraObjectId: z.string().min(1),
    displayName: z.string().min(1),
    department: z.string().nullable(),
});
export const suspendMemberSchema = z.object({
    reason: z.string().trim().min(1, 'A reason is required').max(512),
});
/**
 * Invite-by-email for a business partner — there is no directory to search
 * (see ExternalInvite), so this is just an email address and an optional
 * display name to show before the partner's first sign-in fills one in.
 */
export const inviteExternalPartnerSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
    displayName: z.string().trim().min(1).optional(),
});
/** An external invite, as an administrator/moderator sees it. */
export const externalInviteSchema = z.object({
    id: z.string(),
    email: z.string(),
    displayName: z.string().nullable(),
    status: externalInviteStatusSchema,
    invitedByUserId: z.string(),
    claimedByUserId: z.string().nullable(),
    createdAt: z.coerce.date(),
    claimedAt: z.coerce.date().nullable(),
});
//# sourceMappingURL=members.js.map